module.exports = "build/assets/storm.587ae78f.png";